export default __webpack_public_path__ + "static/media/Minor Brew of Brawn.479da779.jpg";